import { NgModule, Pipe, PipeTransform } from '@angular/core';

declare let _: any;

@Pipe({
    name: 'nullReplacer',
    standalone: false
})
export class NullReplacerPipe implements PipeTransform {

    transform(value: string, args?: string): any {
        value = String(value).replace(/undefined|null/i, "").trim();
        args  = !_.isEmpty(args) ? args : '--';
        return !_.isEmpty(value) ? value : args;
    }

}

@NgModule({
    declarations: [NullReplacerPipe],
    exports: [NullReplacerPipe],
})
export class NullReplacerPipeModule {}